import MeetOurTeamStyle from '@/styles/components/careers/add-section/_index.module.scss';
import { useTranslation } from 'react-i18next';

export function MeetTeamSection({formik, sidebar_section, customizeCareerAction}){
  const {t} = useTranslation()
  return(
    <div className = {`${MeetOurTeamStyle.MeetTeam}`}>
      <label className = {`${MeetOurTeamStyle.MeetTeam__Title}`}>{t('career:meet_our_team:heading')}</label>
      {/************* First Option ***************/}
      <div className = {`${MeetOurTeamStyle.MeetTeam__FirstOption}`} onClick={(event) => {
            customizeCareerAction.addSection(formik, 'team', 'with_description', t)
          }}>
        <div className = {`${MeetOurTeamStyle.MeetTeam__Content}`}>
            <div className = {`${MeetOurTeamStyle.MeetTeam__SubTitle}`}>
              <h3>{t('career:meet_our_team:heading')}</h3>
            </div>
            <div className = {`${MeetOurTeamStyle.MeetTeam__Cards}`}>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member1.png'></img>
                    </div>
                  </div>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__RightContent}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>{t('career:meet_our_team:member_1:name')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>{t('career:meet_our_team:member_1:designation_1')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Text}`}>
                      <p>{t('career:meet_our_team:member_1:quote')}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member2.png'></img>
                    </div>
                  </div>

                  <div className = {`${MeetOurTeamStyle.MeetTeam__RightContent}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>{t('career:meet_our_team:member_2:name')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>{t('career:meet_our_team:member_2:designation_1')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Text}`}>
                      <p>{t('career:meet_our_team:member_2:quote')}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member3.png'></img>
                    </div>
                  </div>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__RightContent}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>{t('career:meet_our_team:member_3:name')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>{t('career:meet_our_team:member_3:designation_1')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Text}`}>
                      <p>{t('career:meet_our_team:member_3:quote')}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member4.png'></img>
                    </div>
                  </div>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__RightContent}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>{t('career:meet_our_team:member_4:name')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>{t('career:meet_our_team:member_4:designation_1')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Text}`}>
                      <p>{t('career:meet_our_team:member_4:quote')}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member5.png'></img>
                    </div>
                  </div>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__RightContent}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>{t('career:meet_our_team:member_5:name')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>{t('career:meet_our_team:member_5:designation_1')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Text}`}>
                      <p>{t('career:meet_our_team:member_5:quote')}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member6.png'></img>
                    </div>
                  </div>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__RightContent}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>{t('career:meet_our_team:member_6:name')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>{t('career:meet_our_team:member_6:designation_1')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Text}`}>
                      <p>{t('career:meet_our_team:member_6:quote')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div className = {`${MeetOurTeamStyle.MeetTeam__AddBtn} noAddbtn__Inreorder`}>
          <span>{t('button:add_section')}</span>
        </div>
      </div>

      {/************* Second Option ***************/}
      <div className = {`${MeetOurTeamStyle.MeetTeam__SecondOption}`} onClick={(event) => {
            customizeCareerAction.addSection(formik, 'team', 'without_description', t)
          }}>
        <div className = {`${MeetOurTeamStyle.MeetTeam__Content}`}>
            <div className = {`${MeetOurTeamStyle.MeetTeam__SubTitle}`}>
              <h3>{t('career:meet_our_team:heading')}</h3>
            </div>
            <div className = {`${MeetOurTeamStyle.MeetTeam__Cards}`}>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card} ${MeetOurTeamStyle.MeetTeam__SecondOption__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails} ${MeetOurTeamStyle.MeetTeam__MarginAuto}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member1.png'></img>
                    </div>
                  </div>
                </div>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom} ${MeetOurTeamStyle.MeetTeam__Card__TextCenter}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>{t('career:meet_our_team:member_1:name')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>{t('career:meet_our_team:member_6:designation_2')}</label>
                    </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card} ${MeetOurTeamStyle.MeetTeam__SecondOption__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails} ${MeetOurTeamStyle.MeetTeam__MarginAuto}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member2.png'></img>
                    </div>
                  </div>
                </div>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom} ${MeetOurTeamStyle.MeetTeam__Card__TextCenter}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>{t('career:meet_our_team:member_2:name')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>{t('career:meet_our_team:member_6:designation_2')}</label>
                    </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card} ${MeetOurTeamStyle.MeetTeam__SecondOption__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails} ${MeetOurTeamStyle.MeetTeam__MarginAuto}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member3.png'></img>
                    </div>
                  </div>
                </div>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom} ${MeetOurTeamStyle.MeetTeam__Card__TextCenter}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>{t('career:meet_our_team:member_3:name')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>{t('career:meet_our_team:member_6:designation_2')}</label>
                    </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card} ${MeetOurTeamStyle.MeetTeam__SecondOption__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails} ${MeetOurTeamStyle.MeetTeam__MarginAuto}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member4.png'></img>
                    </div>
                  </div>
                </div>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom} ${MeetOurTeamStyle.MeetTeam__Card__TextCenter}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>{t('career:meet_our_team:member_4:name')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>{t('career:meet_our_team:member_6:designation_2')}</label>
                    </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card} ${MeetOurTeamStyle.MeetTeam__SecondOption__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails} ${MeetOurTeamStyle.MeetTeam__MarginAuto}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member5.png'></img>
                    </div>
                  </div>
                </div>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom} ${MeetOurTeamStyle.MeetTeam__Card__TextCenter}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>{t('career:meet_our_team:member_5:name')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>{t('career:meet_our_team:member_6:designation_2')}</label>
                    </div>
                </div>
              </div>
              <div className = {`${MeetOurTeamStyle.MeetTeam__Card} ${MeetOurTeamStyle.MeetTeam__SecondOption__Card}`}>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Top}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__UserDetails} ${MeetOurTeamStyle.MeetTeam__MarginAuto}`}>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Icon}`}>
                      <img src = '/images/pages/career/meet_our_team/member6.png'></img>
                    </div>
                  </div>
                </div>
                <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom} ${MeetOurTeamStyle.MeetTeam__Card__TextCenter}`}>
                  <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Name}`}>
                      <label>{t('career:meet_our_team:member_6:name')}</label>
                    </div>
                    <div className = {`${MeetOurTeamStyle.MeetTeam__Card__Bottom__Designation}`}>
                      <label>{t('career:meet_our_team:member_6:designation_2')}</label>
                    </div>
                </div>
              </div>
            </div>
        </div>
        <div className = {`${MeetOurTeamStyle.MeetTeam__AddBtn} noAddbtn__Inreorder`}>
          <span>{(t('button:add_section'))}</span>
        </div>
      </div>
    </div>
  )
}